import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { ModalButtonClose } from "../common/ModalButtonClose";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { TimerCountdown } from "../timer/TimerCountdown";
export var FarmEventDetailsContainer = function (_a) {
    var remainingTime = _a.remainingTime, onClose = _a.onClose, children = _a.children;
    return (React.createElement("div", { className: "farm-events__details-container flex flex--centered" },
        children,
        React.createElement("div", { className: IdStyles.PurchasePointsEventWoodFrame + " flex flex--guts wood-frame farm-events__wood-frame" }),
        remainingTime && (React.createElement("div", { className: IdStyles.TraderEventTimerContainer + " flex flex--aligned pl__small farm-events__timer-container" },
            React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconSmall }),
            React.createElement(TimerCountdown, { remainingTime: remainingTime, className: IdStyles.TextBoldAccent + " ml__small" }))),
        React.createElement(ModalButtonClose, { onClick: onClose, className: "farm-events__close-button" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/farm-event/FarmEventDetailsContainer.tsx
// module id = 610
// module chunks = 3